import glamorous from 'glamorous'
import PropTypes from 'prop-types'

import { COLORS } from 'config'

/** Big photo of a person. */
const Photo = glamorous.img({
  position: 'absolute',
  zIndex: 1,
  top: 0,
  left: 0,
  display: 'block',
  width: '100%',
  height: '100%',
  backgroundColor: COLORS.silver,
  objectFit: 'cover',
  userDrag: 'none',
  userSelect: 'none',
  WebkitUserDrag: 'none',
  transition: 'opacity 120ms'
}, ({ isVisible }) => ({
  opacity: isVisible ? 1 : 0
}))

Photo.propTypes = {
  /** URL of the image */
  src: PropTypes.string.isRequired,
  /** Whether the image should be visible or not */
  isVisible: PropTypes.bool
}

Photo.defaultProps = {
  isVisible: false
}

export default Photo



// WEBPACK FOOTER //
// ./src/components/cards/Photo.js